import { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { QueryClient } from "@tanstack/react-query";
import { GqlOperationFactory } from "./GqlOperationFactory";
import { GqlQuery } from "./GqlQuery";
import { GqlQueryWithTransformer } from "./GqlQueryWithTransformer";

export class GqlQueryFactory {
  private _gqlOperationFactory: GqlOperationFactory;
  private _queryClient: QueryClient;
  constructor(args: { gqlOperationFactory: GqlOperationFactory; queryClient: QueryClient }) {
    this._gqlOperationFactory = args.gqlOperationFactory;
    this._queryClient = args.queryClient;
  }

  createFromGql<V extends Record<string, unknown>, D extends Record<string, unknown>>(options: {
    canWorkWithShareLinks: boolean;
    document: TypedDocumentNode<D, V>;
  }) {
    const operation = this._gqlOperationFactory.createFromGql(options);
    return new GqlQuery({ operation, queryClient: this._queryClient });
  }

  createGqlQueryWithTransformerFromGqlQuery<V extends Record<string, unknown>, D extends Record<string, unknown>, O>(options: {
    gqlQuery: GqlQuery<V, D>;
    transformer: (data: D) => O;
  }) {
    return new GqlQueryWithTransformer({ gqlQuery: options.gqlQuery, transformer: options.transformer });
  }
}
  